import { makeResetStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeResetStyles({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',

  '& .recommendation-container': {
    width: '320px',
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    ...shorthands.borderRadius('8px'),
    boxSizing: 'border-box',
    ...shorthands.padding('16px', '16px', '28px', '16px'),

    '& .recommendation-title': {
      marginBottom: '16px',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '242x',
      color: 'rgba(36, 36, 36, 1)',
    },

    '& .recommendation-content': {
      '& .recommendation-item': {
        display: 'flex',
        marginBottom: '16px',
        cursor: 'pointer',
        paddingLeft: '12px',
        paddingTop: '6px',
        alignItems: 'flex-start',

        '& .icon-box': {
          marginRight: '8px',
          flexShrink: '0',
        },

        '& .item-content': {
          flexGrow: '1',

          '& .item-title': {
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '20px',
            color: 'rgba(66, 66, 66, 1)',
            marginBottom: '6px',
          },
          '& .item-desc': {
            fontSize: '12px',
            lineHeight: '16px',
            color: 'rgba(97, 97, 97, 1)',
          },
        },
      },
    },
  },
  '& .main-image-container': {
    display: 'flex',
    justifyContent: 'center',
    ...shorthands.margin('84px', '12px', '12px', '12px'),
    flexShrink: '1',
    flexGrow: '1',

    '& .image-wrapper': {
      width: '833px',

      '& img': {
        display: 'inline-block',
        width: '100%',
        height: 'auto',
        ...shorthands.borderRadius('8px'),
      },
    },
  },
});
